<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        <strong id="base-two-brand">B A S E &nbsp; T W O</strong>
                    </div>
                    <div>
                        <small>www.wearebasetwo.com</small>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'starter-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
    #base-two-brand{
        font-family: "Montserrat", sans-serif;
        font-size: 1rem;
        font-weight: 400;
        color: #413e66;
    }
</style>
